module.exports = "/images/sort-down-solid.svg?63fbce5456fe57c606053c49a76101e0";


//////////////////
// WEBPACK FOOTER
// ./public/icons/sort-down-solid.svg
// module id = Q1OA
// module chunks = 0